/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Button_SubmitInputs */

const es_components_ask_questions_button_submit = /** @type {(inputs: Components_Ask_Questions_Button_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar respuestas`)
};

const en_components_ask_questions_button_submit = /** @type {(inputs: Components_Ask_Questions_Button_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send answers`)
};

/**
* | output |
* | --- |
* | "Send answers" |
*
* @param {Components_Ask_Questions_Button_SubmitInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_button_submit = /** @type {((inputs?: Components_Ask_Questions_Button_SubmitInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Button_SubmitInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_button_submit(inputs)
	return en_components_ask_questions_button_submit(inputs)
});
export { components_ask_questions_button_submit as "components.ask_questions.button.submit" }